import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// import config
import config from '../config';

// import component
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import ForgotPin from '../components/ForgotPin';
import Footer from "components/Footer/Footer.js";

import styles from "assets/jss/material-kit-react/views/loginPage.js";

const useStyles = makeStyles(styles);
function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}
const dashboardRoutes = [];
const ForgotPinPage = (props) => {
  const classes = useStyles();
  const { ...rest } = props;

  return (
    <div className="page_wrap page_wrap_dark">
      <ScrollToTopOnMount />
      <Header className="header"
        color="transparent"
        routes={dashboardRoutes}
        brand={<img src={require("../assets/images/logo_light.png")} alt="logo" className="img-fluid" />}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 20,
          color: "dark",
        }}
        {...rest} />
    <GoogleReCaptchaProvider reCaptchaKey={config.RECAPTCHA_SITE_KEY}>
      <ForgotPin />
    </GoogleReCaptchaProvider>  
      <Footer />
    </div>
  );
}

export default ForgotPinPage;